import { getLayoutProps } from '@/utils/layout/layout';
import React from 'react';
import PageLayout from '@/components/PageLayout';
import StorePageSection from '@/components/StoresPage/StoresPage';
import Head from 'next/head';
import { getOrFetchCorporateData } from '@/utils/corporateCalls';
import styles from '@/styles/Corporate.module.css';
import { CustomMetaHead } from '@/components/CustomMetaHead/CustomMetaHead';

export default function Stores({ responsiveLogo, stores, metadata }) {
  if (stores.hasOwnProperty('empty')) return;
  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <CustomMetaHead metadata={metadata} />

      <main className={styles.mainContainer}>
        <div className={styles.categoriesContainer}>
          {stores && <StorePageSection stores={stores} responsiveLogo={responsiveLogo} />}
        </div>
      </main>
    </>
  );
}

Stores.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticProps(context) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);
  const [{ data: corporateData }, { data: storesData }] = await Promise.all([
    getOrFetchCorporateData('corporate_page', context.locale),
    getOrFetchCorporateData('storescorporatepage', context.locale),
  ]);

  const corporates = corporateData.data;
  const stores = storesData.data[0] ? storesData : { empty: true };
  const metadata = stores?.data[0]?.content?.metadata;

  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      corporates,
      stores,
      messages,
      ...(metadata ? { metadata } : null),
    },
  };
}
